// src/pages/ServiceAccountLedger/ServiceAccountLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchServiceAccountLedger,
  fetchServiceAccountsBySearch,
} from "./ServiceAccountLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  serviceAccounts: [],
  serviceAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const serviceAccountLedgerSlice = createSlice({
  name: "serviceAccountLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceAccountLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceAccountLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchServiceAccountLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchServiceAccountsBySearch.pending, (state) => {
        state.serviceAccountLoading = true;
      })
      .addCase(fetchServiceAccountsBySearch.fulfilled, (state, action) => {
        state.serviceAccountLoading = false;
        state.serviceAccounts = action.payload;
      })
      .addCase(fetchServiceAccountsBySearch.rejected, (state) => {
        state.serviceAccountLoading = false;
        state.serviceAccounts = [];
      });
  },
});

export const { setFilters } = serviceAccountLedgerSlice.actions;
export default serviceAccountLedgerSlice.reducer;
